import { PreorderApp } from "./PreorderApp";
window.BasePreorderApp = PreorderApp;
